import { render, staticRenderFns } from "./add-team.vue?vue&type=template&id=7b97727b&scoped=true"
import script from "./add-team.vue?vue&type=script&lang=js"
export * from "./add-team.vue?vue&type=script&lang=js"
import style0 from "./add-team.vue?vue&type=style&index=0&id=7b97727b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97727b",
  null
  
)

export default component.exports